import {
  ARENDE_ON_ADD_ARENDE,
  ARENDE_ON_GET_ARENDE,
  ARENDE_ON_GET_ARENDEN,
  ARENDE_ON_START_GET_THIS_ARENDE,
  ARENDE_ON_GET_ARENDEN_COUNT,
  ARENDE_ON_GET_ARENDEN_COUNT_ALL,
  ARENDE_ON_GET_FLODE,
  ARENDE_ON_START_GET_FLODE,
  ARENDE_ON_ERROR_GET_FLODE,
  ARENDE_ON_GET_ARTIKLAR,
  ARENDE_ON_GET_ARTIKLAR_COUNT,

  ARENDE_ON_START_POST_FLODE,
  ARENDE_ON_ERROR_POST_FLODE,
  ARENDE_ON_POST_FLODE,

  ARENDE_ON_GET_MEDARBETARE,
  ARENDE_ON_ADD_MEDARBETARE,
  ARENDE_ON_REMOVE_MEDARBETARE,
  SET_ARENDE_NUM_DOC,

  ARENDE_ON_ADD_ASSISTANSBÅT,
  ARENDE_ON_GET_ASSISTANSBÅTAR,
  ARENDE_ON_REMOVE_ASSISTANSBÅT,

  ARENDE_ON_START_UPDATE_ARENDE,
  ARENDE_ON_UPDATE_ARENDE,
  ARENDE_ON_ERROR_UPDATE_ARENDE,

  ARENDE_ON_START_GET_CASE_PDF_REPORT,
  ARENDE_ON_ERROR_GET_CASE_PDF_REPORT, 
  ARENDE_ON_GET_CASE_PDF_REPORT,

  ARENDE_ON_GET_INFO,
  ARENDE_ON_ADD_INFO,
  ARENDE_ON_DELETE_INFO,
  ARENDE_ON_UPDATE_INFO,
  ARENDE_ON_GET_EKONOMI,
  ARENDE_ON_ADD_EKONOMI,
  ARENDE_ON_DELETE_EKONOMI,
  ARENDE_ON_UPDATE_EKONOMI,
  ARENDE_ON_GET_OLYCKSPLATS,
  ARENDE_ON_SEARCH_ARENDEN,
  ARENDE_ON_START_SEARCH_ARENDEN,
  ARENDE_ON_ERROR_SEARCH_ARENDEN,
  ARENDE_ON_START_GET_HISTORIK,
  ARENDE_ON_GET_HISTORIK,
  ARENDE_ON_START_GET_ARENDE,
  ON_OPEN_FILTER_ARENDE,
  ON_ClOSE_FILTER_ARENDE,
  SET_ARENDE_FILTER,
  ON_START_GET_ARANDE_KEDJA,ON_GET_ARANDE_KEDJA,ON_ERROR_GET_ARANDE_KEDJA,


  ON_SAVE_ARENDE_CALC_ITEMS,
  ON_START_SAVE_ARENDE_CALC_ITEMS, 
  ON_ERROR_SAVE_ARENDE_CALC_ITEMS,
  ON_START_NEW_ARENDE_KALKYL_ID,
  ON_NEW_ARENDE_KALKYL_ID ,
  ON_ERROR_NEW_ARENDE_KALKYL_ID,
  ON_START_NEW_ARENDE_ABOKALKYL_ID ,
  ON_NEW_ARENDE_ABOKALKYL_ID ,
  ON_ERROR_NEW_ARENDE_ABOKALKYL_ID ,
  ON_START_GET_ARENDE_KALKYL_ID,
  ON_GET_ARENDE_KALKYL_ID ,
  ON_ERROR_GET_ARENDE_KALKYL_ID,
  ON_START_DELETE_ARENDE_KALKYL_RAD ,
  ON_DELETE_ARENDE_KALKYL_RAD ,
  ON_ERROR_DELETE_ARENDE_KALKYL_RAD ,
  ON_START_UPDATE_ARENDE_KALKYL_RAD,
  ON_UPDATE_ARENDE_KALKYL_RAD ,
  ON_ERROR_UPDATE_ARENDE_KALKYL_RAD ,

  ARENDE_ON_START_GET_DOKUMENT,
  ARENDE_ON_GET_DOKUMENT,
  SET_ZERO_ARENDE,
  ON_GET_ARENDE_PAGE_BASIC,
	ON_GET_ARENDE_FILTER_BASIC,
  ON_GET_ANTAL_AKTIVITETER_ARENDE,

  ON_CLOSE_ARANDE_TOASTR,
  ON_START_UPDATE_ARENDE_MESSAGE,ON_UPDATE_ARENDE_MESSAGE,ON_ERROR_UPDATE_ARENDE_MESSAGE,
}  from '../constants/ActionTypes'
import {isUndefined,isEmpty, isNull} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
  response: null,
  currentArende: {},
  currentArendeHistorik: [],
  arenden: [],
  Kedjaarenden: [],
  count: 0,
  count_All: 0,
  KedjaArandecount: 0,
  artikelCount: 0,
  flode: [],
  KStatusList: [],
  artiklar: [],
  medarbetare: [],
  assistansbåtar: [],
  info: null,
  ekonomi: null,
  olycksplats: null,
  FilterArendePopup:false,
  ArendeFilterOption: isUndefined(localStorage.ArendeFilter)?[]:JSON.parse(localStorage.ArendeFilter),
  DocumentList:[],
  DocumentListCount: 0,
  ArendeLoading:false,
  ArendePage: 1,
  ArendeFilter: 1,
  sortObj: isUndefined(localStorage.ArendeSortObj)?null:JSON.parse(localStorage.ArendeSortObj),
  currentProjectKalkyl: [],
  ResponseArandeMsg:{},
  flodeLoading:false,
  MessageFromEmail: null
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case ON_OPEN_FILTER_ARENDE: {
      console.log("ON_OPEN_FILTER_ARENDE", action.payload)
      return {
        ...state, 
        FilterArendePopup:true,
        
        ArendeFilterOption:isUndefined(localStorage.ArendeFilter)?[]:JSON.parse(localStorage.ArendeFilter)
      }
    }
    case ON_GET_ANTAL_AKTIVITETER_ARENDE:{
      console.log("ON_GET_ANTAL_AKTIVITETER_ARENDE",action)
      return {
        ...state,
        currentArende:{
          ...state.currentArende,
          numAktivitet: action.payload.Aktiveteter.length
        }
      }
    }

    case ON_SAVE_ARENDE_CALC_ITEMS: {
      return {
        ...state,
        currentArendeKalkyl:action.payload.Kalkyl,
        ResponseArandeMsg:{msg:translate("Action.Save"),type:"success",loading:false},
      }
    }
    case ON_START_SAVE_ARENDE_CALC_ITEMS: {
      return {
        ...state,
        ResponseArandeMsg:{msg:translate("Action.saving"),type:"info",loading:true},
      }
    }
    case ON_ERROR_SAVE_ARENDE_CALC_ITEMS: {
      return {
        ...state,
        ResponseArandeMsg:{msg:translate("notification.error"),type:"error",loading:true},
      }
    }
    case ON_START_NEW_ARENDE_KALKYL_ID: {
      console.log("ON_START_NEW_ARENDE_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_NEW_ARENDE_KALKYL_ID: {
      console.log("ON_NEW_ARENDE_KALKYL_ID", action.payload)
      return {
        ...state,
        currentArendeKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_NEW_ARENDE_KALKYL_ID: {
      console.log("ON_ERROR_NEW_ARENDE_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_START_NEW_ARENDE_ABOKALKYL_ID: {
      console.log("ON_START_NEW_ARENDE_ABOKALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_NEW_ARENDE_ABOKALKYL_ID: {
      console.log("ON_NEW_ARENDE_ABOKALKYL_ID", action.payload)
      return {
        ...state,
        currentArendeKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_NEW_ARENDE_ABOKALKYL_ID: {
      console.log("ON_ERROR_NEW_ARENDE_ABOKALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_START_GET_ARENDE_KALKYL_ID: {
      console.log("ON_START_GET_ARENDE_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    

    case ARENDE_ON_START_POST_FLODE: {
      return {
        ...state,
      }
    }
    case ARENDE_ON_ERROR_POST_FLODE: {
      return {
        ...state,
      }
    }
    case ARENDE_ON_POST_FLODE: {
      return {
        ...state,
        currentArende: {
          ...state.currentArende,
          ...action.payload.arende
        }
      }
    }

    case ON_GET_ARENDE_KALKYL_ID: {
      console.log("ON_GET_ARENDE_KALKYL_ID", action.payload)
      return {
        ...state,
        currentArendeKalkyl:action.payload.Kalkyl,        
      }
    }
    case ON_ERROR_GET_ARENDE_KALKYL_ID: {
      console.log("ON_ERROR_GET_ARENDE_KALKYL_ID", action.payload)
      return {
        ...state
      }
    }
    case ON_START_DELETE_ARENDE_KALKYL_RAD: {
      console.log("ON_START_DELETE_ARENDE_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_DELETE_ARENDE_KALKYL_RAD: {
      console.log("ON_DELETE_ARENDE_KALKYL_RAD", action.payload)
      return {
        ...state,
        currentArendeKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_DELETE_ARENDE_KALKYL_RAD: {
      console.log("ON_ERROR_DELETE_ARENDE_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_START_UPDATE_ARENDE_KALKYL_RAD: {
      console.log("ON_START_UPDATE_ARENDE_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_UPDATE_ARENDE_KALKYL_RAD: {
      console.log("ON_UPDATE_ARENDE_KALKYL_RAD", action.payload)
      return {
        ...state,
        currentArendeKalkyl:action.payload.Kalkyl,
      }
    }
    case ON_ERROR_UPDATE_ARENDE_KALKYL_RAD: {
      console.log("ON_UPDATE_ARENDE_KALKYL_RAD", action.payload)
      return {
        ...state
      }
    }
    case ON_GET_ARENDE_PAGE_BASIC:{
      return {
        ...state,
        ArendePage:action.payload.Page
      }
    }
    case ON_GET_ARENDE_FILTER_BASIC:{
      return {
        ...state,
        ArendeFilter:action.payload.Filter
      }
    }
    case ON_ClOSE_FILTER_ARENDE: {
      console.log("ON_ClOSE_FILTER_ARENDE", action.payload)
      return {...state, FilterArendePopup:false}
    }
    case SET_ARENDE_FILTER: {
      console.log("SET_ARENDE_FILTER", action.payload)
      localStorage.removeItem("ArendeFilter");
      localStorage.setItem("ArendeFilter", JSON.stringify(action.payload));
      return {...state, ArendeFilterOption: action.payload}
    }
    case ARENDE_ON_ADD_ARENDE: {
      console.log("ARENDE_ON_ADD_ARENDE", action.payload)
      return state
    }
    case ARENDE_ON_GET_ARENDE: {
      console.log("ARENDE_ON_GET_ARENDE", action.payload)
      let ekonomi = isNull(action.payload[1]) ? {
        Upris: 0,
        Vpris: 0,
        Faktura: 0
      } : action.payload[1]
      let olycksplats = isNull(action.payload[2]) ? {
        Lat:0,
        Lng:0,
        Forsakringsnr:"",
        Skadeplats:"",
        Båtmodell:"",
        Båtid:"",
        Båttillverkare:"",
        Region:""
      } : action.payload[2]
      return {...state, 
        ResponseArandeMsg:{},
        currentArende: action.payload[0], 
        ekonomi: ekonomi,
        olycksplats: olycksplats,
        medarbetare: action.payload[3],
        ArendeLoading:false
      }
    }
    case ARENDE_ON_START_GET_THIS_ARENDE: {
      return {
        ...state, 
        ResponseArandeMsg:{msg:translate("Action.fetching.Errand"),type:"info",loading:true},
        response: null,
        currentArende: {},
        ArendeLoading:true
      }
    }
    case ARENDE_ON_GET_ARENDEN: {
      console.log("ARENDE_ON_GET_ARENDEN", action.payload)

      localStorage.removeItem("ArendeSortObj");
      if(!isUndefined(JSON.stringify(action.payload.SortObj))){
        localStorage.setItem("ArendeSortObj", JSON.stringify(action.payload.SortObj));
        }
      return {
        ...state, 
        arenden: action.payload.results, 
        count: action.payload.count, 
        ResponseArandeMsg:{msg:translate("Action.fetch.Errand"),type:"success",loading:false},
        ArendeLoading: false, 
        sortObj: isUndefined(JSON.stringify(action.payload.SortObj))?{"column":"sdate","Type":0}:action.payload.SortObj,
      }
    }

 	 	case ARENDE_ON_START_SEARCH_ARENDEN:{
      console.log("ARENDE_ON_START_SEARCH_ARENDEN", action.payload)
      return {
        ...state, 
        arenden: [], 
        ArendeLoading: true, 
      }
		}
 	 	case ARENDE_ON_ERROR_SEARCH_ARENDEN:{
      console.log("ARENDE_ON_ERROR_SEARCH_ARENDEN", action.payload)
      return {
        ...state, 
        arenden: [], 
        count: 0, 
        ArendeLoading: false, 
      }
		}
    case ARENDE_ON_SEARCH_ARENDEN: {
      console.log("ARENDE_ON_SEARCH_ARENDEN", action.payload)

      localStorage.removeItem("ArendeSortObj");
      if(!isUndefined(JSON.stringify(action.payload.SortObj))){
        localStorage.setItem("ArendeSortObj", JSON.stringify(action.payload.SortObj));
        }

      return {
        ...state, 
        arenden: action.payload.Arenden, 
        count: action.payload.count, 
        ArendeLoading: false, 
        sortObj:isUndefined(JSON.stringify(action.payload.SortObj))?{"column":"sdate","Type":0}:action.payload.SortObj,
      }
    }
    case ARENDE_ON_START_GET_ARENDE: {
      return {
        ...state, 
        ResponseArandeMsg:{msg:translate("Action.fetching.Errands"),type:"info",loading:true},
        //arenden: [],
        // Kedjaarenden: [],
        //count: 0,
        ArendeLoading: true
      }
    }
    case ARENDE_ON_GET_ARENDEN_COUNT: {
      console.log("ARENDE_ON_GET_ARENDEN_COUNT", action.payload)
      return { ...state,
         count: action.payload[0].count
        };
    }
    case ARENDE_ON_GET_ARENDEN_COUNT_ALL: {
      console.log("ARENDE_ON_GET_ARENDEN_COUNT", action.payload)
      return { ...state, count_All: action.payload[0].count};
    }
    case ARENDE_ON_GET_ARTIKLAR_COUNT: {
      console.log("ARENDE_ON_GET_ARTIKLAR_COUNT", action.payload)
      return { ...state, artikelCount: action.payload[0]["COUNT(*)"]};
    }
    case ARENDE_ON_GET_FLODE: {
      console.log("ARENDE_ON_GET_FLODE", action.payload)
      return { ...state, flode: action.payload.flode, MessageFromEmail:action.payload.MessageFromEmail, flodeLoading: false};
    }
    case ARENDE_ON_START_GET_FLODE: {
      return { ...state, flode: [], flodeLoading: true};
    }
    case ARENDE_ON_ERROR_GET_FLODE:{
      return { ...state, flode: [], flodeLoading: false};
    }
    case ARENDE_ON_GET_ARTIKLAR: {
      console.log("ARENDE_ON_GET_ARTIKLAR", action.payload)
      return { ...state, artiklar: action.payload};
    }
    case ARENDE_ON_GET_MEDARBETARE: {
      console.log("ARENDE_ON_GET_MEDARBETARE", action.payload)

      return {...state, medarbetare: action.payload}
    }
    case ARENDE_ON_GET_ASSISTANSBÅTAR: {
      console.log("ARENDE_ON_GET_ASSISTANSBÅTAR", action.payload)

      return {...state, assistansbåtar: action.payload}
    }
    case ARENDE_ON_GET_INFO: {
      console.log("ARENDE_ON_GET_INFO", action.payload)

      return {...state, info: action.payload}
    }
    case ARENDE_ON_GET_EKONOMI: {
      console.log("ARENDE_ON_GET_EKONOMI", action.payload)

      return {...state, ekonomi: action.payload}
    }
    case ARENDE_ON_START_GET_HISTORIK: {
      console.log("ARENDE_ON_START_GET_HISTORIK", action.payload)

      return {...state, currentArendeHistorik: []}
    }
    case ARENDE_ON_GET_HISTORIK: {
      console.log("ARENDE_ON_GET_HISTORIK", action.payload)

      return {...state, currentArendeHistorik: action.payload}
    }
    case ARENDE_ON_GET_OLYCKSPLATS: {
      console.log("ARENDE_ON_GET_OLYCKSPLATS", action.payload)
      let olycksplats = isNull(action.payload) ? {
        Lat:0,
        Lng:0,
        Forsakringsnr:"",
        Skadeplats:"",
        Båtmodell:"",
        Båtid:"",
        Båttillverkare:"",
        Region:""
      } : action.payload
      return {...state, olycksplats: olycksplats}
    }
    //ON_START_GET_ARANDE_KEDJA,ON_GET_ARANDE_KEDJA,ON_ERROR_GET_ARANDE_KEDJA,
    case ON_START_GET_ARANDE_KEDJA:{
      console.log("ON_START_GET_ARANDE_KEDJA",action)
      return {
        ...state,
        ArendeLoading:true,
      }
    }
    
    case ON_GET_ARANDE_KEDJA:{
      console.log("ON_GET_ARANDE_KEDJA",action)
      return {
        ...state,
        ArendeLoading:false,
        Kedjaarenden:action.payload.Kedjaarenden,
        KedjaArandecount:action.payload.KedjaArandecount,
        KStatusList:action.payload.KStatusList,
      }
    }
    case ON_ERROR_GET_ARANDE_KEDJA:{
      console.log("ON_ERROR_GET_ARANDE_KEDJA",action)
      return {
        ...state,
        ArendeLoading:false,
      }
    }
    case ARENDE_ON_START_GET_DOKUMENT:{
      console.log("ARENDE_ON_START_GET_DOKUMENT",action)
      return {
        ...state,
        //ResponseArandeMsg:{msg:"Hämtar dokumentlista",type:"info",loading:true},
        DocumentList:[],
        DocumentListCount: 0
      }
    }
    case ARENDE_ON_GET_DOKUMENT:{
      console.log("ARENDE_ON_GET_DOKUMENT",action)
      return {
        ...state,
        //ResponseArandeMsg:{msg:"Dokumentlista har hämtat",type:"info",loading:true},
        DocumentList: action.payload.Documents,
        DocumentListCount: action.payload.Count
      }
    }
    case ARENDE_ON_START_UPDATE_ARENDE: {
      return {...state, 
        ArendeLoading:true,
        ResponseArandeMsg:{msg:translate("Action.saving.Errand"),type:"info",loading:true},
        response: null}
    }
    case ARENDE_ON_UPDATE_ARENDE: {
      let ekonomi = isNull(action.payload[1]) ? {
        Upris: 0,
        Vpris: 0,
        Faktura: 0
      } : action.payload[1]
      let olycksplats = isNull(action.payload[2]) ? {
        Lat:0,
        Lng:0,
        Forsakringsnr:"",
        Skadeplats:"",
        Båtmodell:"",
        Båtid:"",
        Båttillverkare:"",
        Region:""
      } : action.payload[2]
      return {...state, 
        ResponseArandeMsg:{msg:translate("Action.saved.Errand"),type:"success",loading:false},
        currentArende: action.payload[0], 
        ekonomi: ekonomi,
        olycksplats: olycksplats,
        medarbetare: action.payload[3],
        ArendeLoading:false
      }
    }
    case ARENDE_ON_ERROR_UPDATE_ARENDE: {
      return {...state, response: { success: false, message: translate("Action.error.Errand") },
        ArendeLoading:false,
        ResponseArandeMsg:{msg:translate("Action.error.Errand"),type:"error",loading:false},
      }
    }

    case ARENDE_ON_START_GET_CASE_PDF_REPORT: {
      return {...state, 
        ResponseArandeMsg:{msg:translate("Action.fetching.ErrandReport"),type:"info",loading:true},
    	}
    }
    case ARENDE_ON_GET_CASE_PDF_REPORT: {
      return {...state, 
        ResponseArandeMsg:{msg:translate("Action.fetch.ErrandReport"),type:"success",loading:false},
 		   }
		}
    case ARENDE_ON_ERROR_GET_CASE_PDF_REPORT: {
      return {...state, 
        ResponseArandeMsg:{msg:translate("Error.fetch.ErrandReport"),type:"error",loading:false},
			}
    }
    case SET_ARENDE_NUM_DOC: {
      return {
        ...state,
        currentArende: {
          ...state.currentArende,
          numDoc: action.payload.numDoc
        }
      }
    }
    //ON_CLOSE_ARANDE_TOASTR
    case ON_CLOSE_ARANDE_TOASTR:{
      return {
        ...state,
        ResponseArandeMsg:{}
      }
    }
    case SET_ZERO_ARENDE: {
      return INIT_STATE;
    }
    //ON_START_UPDATE_ARENDE_MESSAGE,ON_UPDATE_ARENDE_MESSAGE,ON_ERROR_UPDATE_ARENDE_MESSAGE,
    case ON_START_UPDATE_ARENDE_MESSAGE: {
      return {...state, response: null}
    }
    case ON_UPDATE_ARENDE_MESSAGE: {
      return {...state, 
        response: {success: true, message: translate("Action.Save.Errend.event")}
      }
    }
    case ON_ERROR_UPDATE_ARENDE_MESSAGE: {
      return {
        ...state, 
        response: {success: false, message: translate("Error.Save.Errend.event")}
      }
    }
  //,
    default: {
      return state
    }
  }
}
